export enum Permissions {
    CREDIT_APPLICATION = 'CreditApplicationPermission',
    DEALER_RENTAL = 'DealerRentalPermission',
    FUNDING_STATUS = 'FundingStatusPermission',
    MARKETING_BULLETINS = 'MarketingBulletinsPermission',
    APPLICATION_STATUS_TRACKING = 'ApplicationStatusTrackingPermission',
    PAYOFF_QUOTES = 'PayoffQuotesPermission',
    USER_ADMIN = 'UserAdminPermission',
    DEALER_RESERVES_EFT_NOTIFICATIONS = 'DealerReservesEFTNotificationsPermission',
    ASSIGN_MANAGE_SALES_MATURITIES = 'AssignManageSalesMaturitiesPermission',
    VIEW_MATURITIES = 'ViewSalesMaturitiesPermission',
    QUICK_FUND_SAVE = 'QuickFundSavePermission',
    QUICK_FUND_VIEW = 'QuickFundViewPermission',
    DISTRIBUTION_RULE_MANAGEMENT = 'DistributionRuleManagementPermission',
    NEWS_STORY_MANAGEMENT = 'NewsStoryManagementPermission',
    VEHICLE_MAINTENANCE = 'VehicleMaintenancePermission',
    ONLINE_BULLETINS_MAINTENANCE = 'OnlineBulletinsMaintenancePermission',
    E_DOCUMENT_MAINTENANCE = 'EDocumentMaintenancePermission',
    CV_FORM_MAINTENANCE = 'CvFormMaintenancePermission',
    CONTENT_MAINTENANCE_PERMISSION = 'ContentMaintenancePermission',
    DEALER_SECURITY_MAINTENANCE = 'DealerSecurityMaintenancePermission',
    DEALER_ACTIVATION = 'DealerActivationPermission',
    CREDIT_APPLICATION_MONITOR = 'CreditApplicationMonitorPermission',
    INTERNAL_SECURITY_MAINTENANCE = 'InternalSecurityMaintenancePermission',
    FIELD_ACCESS_MAINTENANCE = 'FieldAccessMaintenancePermission',
    MESSAGE_UTILITY = 'MessageUtilityPermission',
    DEALER_ELECTRONIC_PAYMENT_SUBMIT_AND_APPROVE = 'DealerElectronicPaymentSubmitAndApprovePermission',
    AUDI_DIRECT = 'AudiDirectPermission',
    SERVICE_LOANER = 'ServiceLoanerPermission',
    DEALER_ELECTRONIC_PAYMENT_SUBMIT = 'DealerElectronicPaymentSubmitOnlyPermission',
    FIELD_ACCESS_USER_ADMIN = 'FieldAccessUserAdminPermission',
    VW_AUDI_DIRECT = 'VWAudiDirectPermission',
    VOLKSWAGEN_DIRECT = 'VolkswagenDirectPermission',
    MATURITY_MANAGER = 'MaturityManagerPermission',
    DEALER_ELECTRONIC_PAYMENT = 'DealerElectronicPaymentPermission',
    QUICK_FUND = 'QuickFundPermission',
    QUICK_FUND_NQF = 'CV not required to QF',
    QUICK_FUND_QF = 'CV required to QF',
}
